import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/reportes/reporteSalidasYServicios`, options).then(response => {
    return {
      list: response.data.data,
      meta: response.data.meta
    };
  });
}

function getVentaPorCorrida(corrida_id) {
    const options = {
      headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
      }
    };
  
    return axios.get(`${url}/reportes/analisisVentaPorCorrida/${corrida_id}`, options)
      .then(response => {
        return response.data;
      });
}

function getReporte(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    },
    headers: {
      'Accept': '*/*',
      "Content-Type": "application/vnd.api+json"
    },
    responseType: 'blob',
  };

  return axios.get(`${url}/reportes/descargaReporteSalidasYServicios`, options)
  .then(response => {
    let fileName;
    fileName = `reporteSalidas.xlsx`;

    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
        window.navigator.msSaveOrOpenBlob(new Blob([response.data],
                { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
            ),
            fileName
        );
    } else {
        const url = window.URL.createObjectURL(new Blob([response.data],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    }
  })
  .catch((error) => {
      console.log(error)
    });
}

export default {
  list,
  getVentaPorCorrida,
  getReporte
};
